import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WarningIcon } from 'common/icons';
import { staticStyles } from './style';

const ChangeStatusButtonWarning = () => (
  <div className="ChangeStatusButtonWarning">
    <div className="ChangeStatusButtonWarning__icon-wrapper">
      <WarningIcon />
    </div>
    <FormattedMessage
      id="boChangeStatusWarning"
      values={{
        danger: (
          <FormattedMessage id="boChangeStatusWarningDanger">
            {txt => <span className="ChangeStatusButtonWarning__text-red">{txt}</span>}
          </FormattedMessage>
        ),
        loss: (
          <FormattedMessage id="boChangeStatusWarningLossOfFunds">
            {txt => <span className="ChangeStatusButtonWarning__text-red">{txt}</span>}
          </FormattedMessage>
        ),
      }}
    />

    <style jsx global>
      {staticStyles}
    </style>
  </div>
);

export default ChangeStatusButtonWarning;
